//icons
import {
  mdiAccountMultipleOutline,
  mdiNoteText,
  mdiFerry,
  mdiCogOutline,
  mdiCalendarCheckOutline,
  mdiCertificateOutline,
  mdiGauge,
  mdiStoreOutline,
  mdiCardAccountPhoneOutline
} from "@mdi/js";

import { useActiveRoutePaths } from "../../../services/RouteService";
import { RouteProps } from "../../../models/Route";

export interface MenuItemProps {
  label?: string;
  icon?: any;
  link?: string;
  children?: Array<MenuItemProps>;
  isHeader?: boolean;
  externalUrl?: string;
}

const _menuItems: Array<MenuItemProps> = [
  {
    icon: mdiGauge,
    link: "/dashboard",
  },
  {
    icon: mdiFerry,
    link: "/boat",
  },
  {
    icon: mdiCalendarCheckOutline,
    link: "/orders",
  },
  {
    icon: mdiCardAccountPhoneOutline,
    link: "/leads",
  },
  {
    icon: mdiCertificateOutline,
    isHeader: true,
    label: "Warranty",
    children: [
      {
        link: "/warranty",
        label: "Registrations"
      },
      {
        externalUrl: "https://share.hsforms.com/1f0Emn6MpQumK_gw4Y94uswpza83",
        label: "Warranty Form"
      }
    ]
  },
  {
    icon: mdiNoteText,
    isHeader: true,
    label: "Marketing",
    children: [
      {
        link: "/marketing",
        label: "Documents"
      },
      {
        externalUrl: "https://www.gotaces.com/Account/OpenLink/BPDCrC",
        label: "Dealer Store"
      }
    ]
  },
  {
    icon: mdiAccountMultipleOutline,
    link: "/user",
  },
  {
    icon: mdiStoreOutline,
    link: "/dealer",
  },
  
  {
    icon: mdiCogOutline,
    link: "/config",
  }
];

const useMenuItems = () => {

  const activeRoutePaths = useActiveRoutePaths();
  return getAccessibleMenuItems(_menuItems, activeRoutePaths);

}

const getAccessibleMenuItems = (items: MenuItemProps[], activeRoutePaths: RouteProps[] | undefined) => {

  const authMenuItems: MenuItemProps[] = [];

  items.forEach((item) => {
    let menuItem: MenuItemProps = { ...item };

    const route = activeRoutePaths?.find((x) =>
      (x.path === item.link && item.link !== undefined)
      ||
      (item.isHeader !== undefined && item?.isHeader === true) &&
      ( item.children?.some(c => x.path === c.link && c.link !== undefined) ||
        x.children?.some(child => item.children?.some(c => child.path === c.link && c.link !== undefined)) )
    );
    
    if(menuItem.externalUrl !== undefined) {

      if(menuItem.children) {
        menuItem.children = getAccessibleMenuItems(menuItem.children, activeRoutePaths);
      }

      authMenuItems.push(menuItem);
    }
    
    if(route) {

      if(menuItem.children) {
        menuItem.children = getAccessibleMenuItems(menuItem.children, activeRoutePaths);
      }

      if(item.isHeader !== true) {
        menuItem.label = route.title;
      }
      
      authMenuItems.push(menuItem);
    }

  });

  return authMenuItems;
};

export { useMenuItems };
